import React, { useState } from "react";
import PropTypes from "prop-types";
import "./css/GetLeadsModal.css";

const GetLeadsModal = ({ open, onClose }) => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    city: "",
    requirement: "",
  });

  if (!open) return null;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const submitWhatsApp = () => {
    const message = `New Lead From BizzMark%0A
Name: ${form.name}%0A
Phone: ${form.phone}%0A
City: ${form.city}%0A
Requirement: ${form.requirement}`;

    window.open(
      `https://wa.me/919601961116?text=${message}`,
      "_blank"
    );
  };

  return (
    <div className="leads-overlay" onClick={onClose}>
      <div className="leads-modal" onClick={(e) => e.stopPropagation()}>
        <button className="leads-close" onClick={onClose}>×</button>

        <h2>Get Leads</h2>
        <p>Fill details and connect instantly on WhatsApp</p>

        <input
          name="name"
          placeholder="Your Name"
          onChange={handleChange}
        />
        <input
          name="phone"
          placeholder="Phone Number"
          onChange={handleChange}
        />
        <input
          name="city"
          placeholder="City"
          onChange={handleChange}
        />
        <textarea
          name="requirement"
          placeholder="Your Requirement"
          rows="3"
          onChange={handleChange}
        />

        <button className="whatsapp-btn" onClick={submitWhatsApp}>
          Submit on WhatsApp
        </button>
      </div>
    </div>
  );
};
GetLeadsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default GetLeadsModal;
